import authService from "../../services/AuthService";

export default {
  LOGIN(state) {
    state.isAuthenticated = true;
  },
  LOGOUT(state) {
    state.isAuthenticated = false;
    authService.logout();
  },
};
